import { render, staticRenderFns } from "./ConstraintsPage.vue?vue&type=template&id=959cb678&scoped=true"
import script from "./ConstraintsPage.vue?vue&type=script&lang=js"
export * from "./ConstraintsPage.vue?vue&type=script&lang=js"
import style0 from "./ConstraintsPage.vue?vue&type=style&index=0&id=959cb678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959cb678",
  null
  
)

export default component.exports